import {createSlice} from '@reduxjs/toolkit';
import {RootState} from '../store';
import { IStopAccess } from '../../types/ExploreIntefaces';
interface LoadedMarkerTypes {
    stops: boolean;
    pois: boolean;
    directions: boolean;
    vehicles: boolean;
}
export interface markersInformation {
    stops: Array<any> | null;
    stopFathers: Array<any>;
    pois: Array<any> | null;
    stations: Array<any> | null;
    vehicles: Array<any> | null;
    accesses: Array<IStopAccess>;
    loadedTypes: LoadedMarkerTypes;
    accessSelected: IStopAccess | null;
}

const initialState = {
    markersInformation: {
        stops: [],
        stopFathers: [],
        filteredStops: [],
        pois: [],
        stations: {filtered:[], noFiltered:[]},
        vehicles:[],
        accesses: [],
        accessSelected: null,
        filteredAccesses: [],
        loadedTypes: {
            stops: true,
            pois: (function getFromStorage() {
                const poiMarkerLoaded = JSON.parse(localStorage.getItem('kindMarkersPois') || '{}');
                return poiMarkerLoaded ?? false;
              })(),
            directions: true,
            vehicles: true,
        },
    },
};

export const markersSlice = createSlice({
    name: 'markersSlice',
    initialState,
    reducers: {
        updateStops: (state, action) => {
            state.markersInformation.stops = action.payload?.data;
            state.markersInformation.filteredStops = action.payload?.data;
        },
        updateStopsFiltered: (state, action) => {
            state.markersInformation.filteredStops = action.payload;
        },
        updateAccessesFiltered: (state, action) => {
            state.markersInformation.filteredAccesses = action.payload;
        },
        updateStopFathers: (state, action) => {
            state.markersInformation.stopFathers = action.payload;
        },
        updateAccesses: (state, action) => {
            state.markersInformation.accesses = action.payload;
            state.markersInformation.filteredAccesses = action.payload;
        },
        updatePois: (state, action) => {
            state.markersInformation.pois = action.payload;
        },
        updateStations: (state, action) => {
            if(action.payload?.filter)
                state.markersInformation.stations.filtered = action.payload?.data;
            else{
                state.markersInformation.stations.noFiltered = action.payload?.data;
                state.markersInformation.stations.filtered = action.payload?.data;
            }
        },
        updateVehicles: (state, action) => {
            state.markersInformation.vehicles = action.payload;
        },
        updateAccessSelected: (state, action) => {
            state.markersInformation.accessSelected = action.payload;
        },
        updateLoadedTypePois: (state, action) => {
            localStorage.setItem('kindMarkersPois', JSON.stringify(action.payload))
            //AsyncStorage.setItem('kindMarkersPois', JSON.stringify(action.payload))
            state.markersInformation.loadedTypes.pois = action.payload;
        },
    },
});

export const markersInformation = (state: RootState) =>
    state.markersSlice.markersInformation;

export const accessSelectedState = (state: RootState) =>
    state.markersSlice.markersInformation.accessSelected;

export const stopInfoByStopId = (stopId: string, agencyOriginId: number) => (state: RootState) => {
    const info = state.markersSlice.markersInformation;
    const target = String(stopId);

    const stops = info.stops as any[];
    if (Array.isArray(stops)) {
        const found = stops.find(s => String(s?.code) === target && s?.agencyOriginId === agencyOriginId);
        if (found) return found;
    }

    const stopFathers = info.stopFathers as any[];
    if (Array.isArray(stopFathers)) {
      const found = stopFathers.find(s => String(s?.code) === target && s?.agencyOriginId === agencyOriginId);
      if (found) return found;
    }

    const accesses = info.accesses as any[];
    if (Array.isArray(accesses)) {
      const found = accesses.find(s => String(s?.code) === target && s?.agencyOriginId === agencyOriginId);
      if (found) return found;
    }

    return null;
};